import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Select, InputNumber, Upload, message, Image } from 'antd'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import api from '../../services/api'
import { productApi } from '../../services/api'

const CATEGORIES = ['硬件', '软件', '网络设备', '线材辅料', '服务']

export default function ProductModal({ open, editing, onClose, onSuccess }) {
  const [form] = Form.useForm()
  const isEdit = !!editing
  const [imageUrl, setImageUrl] = useState('')
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    if (open) {
      if (editing) {
        form.setFieldsValue({
          sku: editing.sku,
          name: editing.name,
          category: editing.category,
          spec: editing.spec,
          unit: editing.unit || '台',
          costPrice: editing.costPrice,
          listPrice: editing.listPrice,
          supplier: editing.supplier,
          minStock: editing.minStock || 0,
        })
        setImageUrl(editing.imageUrl || '')
      } else {
        form.resetFields()
        setImageUrl('')
      }
    }
  }, [open, editing, form])

  const handleUpload = async (options) => {
    const { file } = options
    setUploading(true)
    try {
      const formData = new FormData()
      formData.append('image', file)
      const res = await api.post('/products/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      setImageUrl(res.imageUrl)
      message.success('图片上传成功')
    } catch (e) {
      message.error(e?.error || '上传失败')
    } finally {
      setUploading(false)
    }
  }

  const handleRemoveImage = () => {
    setImageUrl('')
  }

  const handleSubmit = async (values) => {
    try {
      const data = { ...values, imageUrl }
      if (isEdit) {
        await productApi.update(editing.id, data)
        message.success('产品已更新')
      } else {
        await productApi.create(data)
        message.success('产品已添加')
      }
      onSuccess()
    } catch (e) {
      message.error(e?.error || '操作失败')
    }
  }

  return (
    <Modal
      title={isEdit ? '编辑产品' : '新增产品'}
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="保存"
      width={560}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ unit: '台', minStock: 0, category: '硬件' }}
        style={{ marginTop: 16 }}
      >
        <Form.Item name="sku" label="SKU" rules={[{ required: true, message: 'SKU 必填' }]}>
          <Input placeholder="产品 SKU 编码" />
        </Form.Item>
        <Form.Item name="name" label="产品名称" rules={[{ required: true, message: '产品名称必填' }]}>
          <Input placeholder="产品名称" />
        </Form.Item>
        <Form.Item name="category" label="分类" rules={[{ required: true }]}>
          <Select placeholder="选择分类">
            {CATEGORIES.map((c) => (
              <Select.Option key={c} value={c}>{c}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="spec" label="规格">
          <Input placeholder="规格型号" />
        </Form.Item>
        <Form.Item name="unit" label="单位">
          <Input placeholder="单位" />
        </Form.Item>
        <Form.Item name="costPrice" label="成本价 (¥)">
          <InputNumber style={{ width: '100%' }} min={0} precision={2} placeholder="成本价格" />
        </Form.Item>
        <Form.Item name="listPrice" label="目录价 (¥)">
          <InputNumber style={{ width: '100%' }} min={0} precision={2} placeholder="销售目录价" />
        </Form.Item>
        <Form.Item name="supplier" label="供应商">
          <Input placeholder="供应商名称" />
        </Form.Item>
        <Form.Item name="minStock" label="最低库存预警">
          <InputNumber style={{ width: '100%' }} min={0} placeholder="低于此数量时预警" />
        </Form.Item>
        <Form.Item label="产品图片">
          {imageUrl ? (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <Image
                src={imageUrl}
                alt="产品图片"
                style={{ maxWidth: 200, maxHeight: 150, borderRadius: 8, border: '1px solid #d9d9d9' }}
              />
              <div style={{ marginTop: 8 }}>
                <a onClick={handleRemoveImage} style={{ color: '#ff4d4f', fontSize: 13 }}>删除图片</a>
              </div>
            </div>
          ) : (
            <Upload
              accept="image/*"
              showUploadList={false}
              customRequest={handleUpload}
            >
              <div style={{
                width: 120, height: 120, border: '1px dashed #d9d9d9', borderRadius: 8,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'border-color 0.3s',
                background: '#fafafa',
              }}>
                {uploading ? (
                  <LoadingOutlined style={{ fontSize: 28, color: '#1677ff' }} />
                ) : (
                  <div style={{ textAlign: 'center', color: '#999' }}>
                    <PlusOutlined style={{ fontSize: 28 }} />
                    <div style={{ marginTop: 8, fontSize: 13 }}>上传图片</div>
                  </div>
                )}
              </div>
            </Upload>
          )}
          <div style={{ color: '#999', fontSize: 12, marginTop: 4 }}>支持 JPG/PNG/GIF/WebP，不超过 5MB</div>
        </Form.Item>
      </Form>
    </Modal>
  )
}
